module.exports = __webpack_public_path__ + "img/dingding.fac7fe71.png";